// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRecordDto } from './IRecordDto';
import {
    IRecordDtoFromJSON,
    IRecordDtoFromJSONTyped,
    IRecordDtoToJSON,
    IRecordDtoToJSONTyped,
} from './IRecordDto';

/**
 * 
 * @export
 * @interface IMultipleRecordsDto
 */
export interface IMultipleRecordsDto {
    /**
     * 
     * @type {Array<IRecordDto>}
     * @memberof IMultipleRecordsDto
     */
    multiple_records?: Array<IRecordDto>;
}

/**
 * Check if a given object implements the IMultipleRecordsDto interface.
 */
export function instanceOfIMultipleRecordsDto(value: object): value is IMultipleRecordsDto {
    return true;
}

export function IMultipleRecordsDtoFromJSON(json: any): IMultipleRecordsDto {
    return IMultipleRecordsDtoFromJSONTyped(json, false);
}

export function IMultipleRecordsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMultipleRecordsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'multiple_records': json['multiple_records'] == null ? undefined : ((json['multiple_records'] as Array<any>).map(IRecordDtoFromJSON)),
    };
}

export function IMultipleRecordsDtoToJSON(json: any): IMultipleRecordsDto {
    return IMultipleRecordsDtoToJSONTyped(json, false);
}

export function IMultipleRecordsDtoToJSONTyped(value?: IMultipleRecordsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'multiple_records': value['multiple_records'] == null ? undefined : ((value['multiple_records'] as Array<any>).map(IRecordDtoToJSON)),
    };
}

